import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    ASSET_AUDITORS_GET_ITEM_FAILURE: "ASSET_AUDITORS_GET_ITEM_FAILURE",
    ASSET_AUDITORS_GET_ITEM_REQUEST: "ASSET_AUDITORS_GET_ITEM_REQUEST",
    ASSET_AUDITORS_GET_ITEM_SUCCESS: "ASSET_AUDITORS_GET_ITEM_SUCCESS",

    ASSET_AUDITORS_SELECT_FAILURE: "ASSET_AUDITORS_SELECT_FAILURE",
    ASSET_AUDITORS_SELECT_REQUEST: "ASSET_AUDITORS_SELECT_REQUEST",
    ASSET_AUDITORS_SELECT_SUCCESS: "ASSET_AUDITORS_SELECT_SUCCESS",

    ASSET_AUDITORS_WRITE_FAILURE: "ASSET_AUDITORS_WRITE_FAILURE",
    ASSET_AUDITORS_WRITE_REQUEST: "ASSET_AUDITORS_WRITE_REQUEST",
    ASSET_AUDITORS_WRITE_SUCCESS: "ASSET_AUDITORS_WRITE_SUCCESS",

    ASSET_AUDITORS_UPDATE_FAILURE: "ASSET_AUDITORS_UPDATE_FAILURE",
    ASSET_AUDITORS_UPDATE_REQUEST: "ASSET_AUDITORS_UPDATE_REQUEST",
    ASSET_AUDITORS_UPDATE_SUCCESS: "ASSET_AUDITORS_UPDATE_SUCCESS",

    ASSET_AUDITORS_CLEAR: "ASSET_AUDITORS_CLEAR",
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.ASSET_AUDITORS_CLEAR,
    }),

    getRequest: ({ auditId, assetId }) => ({
        type: actionTypes.ASSET_AUDITORS_GET_ITEM_REQUEST,
        payload: { auditId, assetId },
        [WAIT_FOR_ACTION]: actionTypes.ASSET_AUDITORS_GET_ITEM_SUCCESS,
        [ERROR_ACTION]: actionTypes.ASSET_AUDITORS_GET_ITEM_FAILURE,
    }),
    getSuccess: (assetAuditor: any) => ({
        type: actionTypes.ASSET_AUDITORS_GET_ITEM_SUCCESS,
        payload: { assetAuditor },
        saveReduxState: true,
    }),
    getFailure: (error: Error) => ({
        type: actionTypes.ASSET_AUDITORS_GET_ITEM_FAILURE,
        error,
    }),

    selectRequest: (assignments, auditId) => ({
        type: actionTypes.ASSET_AUDITORS_SELECT_REQUEST,
        payload: { assignments, auditId },
        [WAIT_FOR_ACTION]: actionTypes.ASSET_AUDITORS_SELECT_SUCCESS,
        [ERROR_ACTION]: actionTypes.ASSET_AUDITORS_SELECT_FAILURE,
    }),
    selectSuccess: (assetAuditors: Array<any>) => ({
        type: actionTypes.ASSET_AUDITORS_SELECT_SUCCESS,
        payload: { assetAuditors },
        saveReduxState: true,
    }),
    selectFailure: (error: Error) => ({
        type: actionTypes.ASSET_AUDITORS_SELECT_FAILURE,
        error,
    }),

    writeRequest: (assetAuditors: Array<any>, status: Number) => ({
        type: actionTypes.ASSET_AUDITORS_WRITE_REQUEST,
        payload: { assetAuditors, status },
        [WAIT_FOR_ACTION]: actionTypes.ASSET_AUDITORS_WRITE_SUCCESS,
        [ERROR_ACTION]: actionTypes.ASSET_AUDITORS_WRITE_FAILURE,
    }),
    writeSuccess: () => ({
        type: actionTypes.ASSET_AUDITORS_WRITE_SUCCESS,
        payload: {},
        saveReduxState: true,
    }),
    writeFailure: (error: Error) => ({
        type: actionTypes.ASSET_AUDITORS_WRITE_FAILURE,
        error,
    }),

    updateRequest: (assetAuditor: Array<any>, assetStatus: String) => ({
        type: actionTypes.ASSET_AUDITORS_UPDATE_REQUEST,
        payload: { assetStatus, assetAuditor },
        [WAIT_FOR_ACTION]: actionTypes.ASSET_AUDITORS_UPDATE_SUCCESS,
        [ERROR_ACTION]: actionTypes.ASSET_AUDITORS_UPDATE_FAILURE,
    }),
    updateSuccess: () => ({
        type: actionTypes.ASSET_AUDITORS_UPDATE_SUCCESS,
        payload: {},
        saveReduxState: true,
    }),
    updateFailure: (error: Error) => ({
        type: actionTypes.ASSET_AUDITORS_UPDATE_FAILURE,
        error,
        saveReduxState: true,
    }),
};

export default {
    create: actionCreators,
    type: actionTypes,
};
